<template>
  <div class="tags">
    <ul class="keywords">
      <!-- <li v-for="(tag, idx) in tags" :key="idx" :class="{'selected': kwd === tag.name}"> -->
        <li v-for="(tag, idx) in tags" :key="idx" :class="{'selected': Number(id) === Number(tag.tag_id) || kwd === tag.name}">
        <router-link :to="{path: '/search', query: {id: tag.tag_id}}">{{tag.name}}</router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  props: ['tags', 'kwd', 'id']
}
</script>
<style scoped lang='sass'>

.tags
  width: 70%
  display: flex
  justify-content: center
  +mobile
    width: 90%

.keywords
  display: flex
  flex-wrap: wrap
  padding: 25px 0
  li
    &.selected
      a
        color: var(--primary-color)
    a
      margin: 0 10px
      color: #888
      font-size: 14px

      &:hover
        color: var(--primary-color)
</style>
